import gql from 'graphql-tag';

export const createNoteType = gql`
  mutation createNoteType(
    $categories: [String]
    $enabled: Boolean
    $name: String
    $aors: [String]
  ) {
    createNoteType(
      categories: $categories
      enabled: $enabled
      name: $name
      aors: $aors
    ) {
      createdBy
      createdDate
      active
      id
      name
      updatedBy
      updatedDate
      version
      aors {
        name
        id
      }
      Categories {
        id
        name
      }
    }
  }
`;
